import { addDisposer } from 'mobx-state-tree';
import { Subject } from 'rxjs';
import { subscribe } from './utils';
export function effect(self, factory) {
    const payloadSource = new Subject();
    const effect$ = factory(payloadSource.asObservable());
    const subscription = subscribe(self, factory, effect$);
    addDisposer(self, () => {
        payloadSource.complete();
        subscription.unsubscribe();
    });
    return (payload) => {
        payloadSource.next(payload);
    };
}
